<script setup lang="ts">

import { useGlobalResellerPresentation } from './GlobalPresentation';
import Presentation from '@presentation/Templates/Presentation.vue';

useGlobalResellerPresentation(); 

</script>

<template>
    <Presentation />
</template>